export default __webpack_public_path__ + "static/media/VRI_logo.f4b10ac5.svg";